export default function Card(props) {
	return (
		<div className={`${props.className}`}>
			<div className={'bg-white h-full rounded-xl shadow-sm'}>
				{props.children}
			</div>
		</div>
	)
}
